// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: calc(100vh - 50px);
  background-color: #f3f3ea;
}

.forgot-password-link {
  color: #3f51b5;
  text-decoration: none; /* Remove default underline */
  cursor: pointer; /* Show pointer cursor on hover */
  font-weight: 600;
}

.forgot-password-link:hover {
  text-decoration: underline; /* Underline on hover */
  color: #3f51b5;
}

.font-size {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/login/login.component.scss"],"names":[],"mappings":"AACC;EACI,8BAAA;EAEA,yBAAA;AADL;;AAOC;EACC,cAAA;EACA,qBAAA,EAAA,6BAAA;EACA,eAAA,EAAA,iCAAA;EACA,gBAAA;AAJF;;AAQA;EACE,0BAAA,EAAA,uBAAA;EACA,cAAA;AALF;;AAWA;EACE,gBAAA;AARF","sourcesContent":["\r\n .login-container{\r\n     min-height: calc(100vh - 50px);\r\n    //  background-color: #fbf9ec;\r\n     background-color: #f3f3ea;\r\n\r\n }\r\n\r\n\r\n\r\n .forgot-password-link {\r\n  color: #3f51b5;\r\n  text-decoration: none; /* Remove default underline */\r\n  cursor: pointer; /* Show pointer cursor on hover */\r\n  font-weight: 600;\r\n\r\n}\r\n\r\n.forgot-password-link:hover {\r\n  text-decoration: underline; /* Underline on hover */\r\n  color: #3f51b5;\r\n  // font-weight: 600;\r\n\r\n\r\n}\r\n\r\n.font-size{\r\n  font-weight:600;\r\n\r\n}\r\n\r\n\r\n// .password-toggle-btn {\r\n//     color: #3f51b5 !important;\r\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
